export enum ButtonType {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  LINK = 'link',
  TEXT = 'text',
  DELETE = 'delete',
}

export enum ButtonSize {
  LARGE = 'large',
  MEDIUM = 'middle',
  SMALL = 'small',
}

export enum ButtonHTMLType {
  SUBMIT = 'submit',
  BUTTON = 'button',
}
